import React, {useState, useContext, useRef, useEffect} from 'react'
import styled from 'styled-components'
import { graphql, useStaticQuery, Link } from 'gatsby'
import SearchIcon from '@material-ui/icons/Search'

import {StateContext} from '../../utils/context'

export default ({isTop}) => {
  const {allMdx: {nodes}} = useStaticQuery(graphql`
    query {
      allMdx(sort:{fields: frontmatter___date, order: DESC},filter:{frontmatter:{show: {eq:"show"}}}) {
        nodes {
          excerpt
          rawBody
          frontmatter {
            title
            type
            category_large
            category_small
          }
          fields {
            slug
            slug_path
          }
        }
      }
    }
  `)

  const [searchedList, setSearchedList] = useState([])
  const {state, dispatch} = useContext(StateContext)
  const refSearching = useRef()
  const refSearchedContainer = useRef()

  const handleClickSearch = () => {
    dispatch({type: 'SearchToggle', payload: true})
    refSearching.current.focus()
  }

  useEffect(() => {
    dispatch({type: 'SetSearchInputRef', payload: refSearching})
    refSearching.current.addEventListener('focusin', () => {
      dispatch({type: 'SearchToggle', payload: true})
    })
    refSearching.current.addEventListener('focusout', () => {
      setTimeout(() => {
        dispatch({type: 'SearchToggle', payload: false})
      }, 100);
    })
    return () => {
      refSearching.current.removeEventListener('focusin', () => {
        dispatch({type: 'SearchToggle', payload: true})
      })
      refSearching.current.removeEventListener('focusout', () => {
        setTimeout(() => {
          dispatch({type: 'SearchToggle', payload: false})
        }, 100);
      })
    }
  }, [])

  useEffect(() => {
    const nodesArr = []
    if (state.searchKeyword) {
      const kArr = state.searchKeyword.toLowerCase().split(' ')
      const keywordArr = kArr.filter((key) => key)

      // filter
      const filtered_node = nodes.filter((info) => {
        let count = 0
        const {frontmatter: {title, category_small}, excerpt, rawBody} = info
        keywordArr.forEach((key) => {
          if (title.toLowerCase().includes(key) ||
          category_small.toLowerCase().includes(key) ||
          excerpt.toLowerCase().includes(key) ||
          rawBody.toLowerCase().includes(key)) count += 1
        })
        return count > 0
      })

      // matching
      const matched_node = filtered_node.map((info) => {
        keywordArr.forEach((key) => {
          info = {...info, frontmatter: {...info.frontmatter, title: confirmMatch(key, info.frontmatter.title.toLowerCase())}}
          info = {...info, excerpt: confirmMatch(key, info.excerpt.toLowerCase())}
          info = {...info, frontmatter: {...info.frontmatter, category_small: confirmMatch(key, info.frontmatter.category_small.toLowerCase())}}
          info = info.rawBody.includes(key) ? {...info, excerpt: confirmMatch('…', info.excerpt.toLowerCase())} : info
        })
        return info
      })
      setSearchedList(matched_node)
    } else {
      setSearchedList(nodesArr)
    }
  }, [state.searchKeyword])

  const confirmMatch = (key, target) => {
    const reg = new RegExp(key, "g")
    return target.replace(reg, `<b class="match">${key}</b>`)
  }

  return (
    <Container>
      <SearchIconContainer onClick={handleClickSearch}>
        <SearchIconStyled searching={`${state.isSearching}`} isTop={isTop}/>
        <SearchInput 
          ref={refSearching} 
          onChange={(e) => dispatch({type: 'SetSearchKeyword', payload: e.target.value})} 
          value={state.searchKeyword}
          searching={`${state.isSearching}`} 
          isTop={isTop}
        />
      </SearchIconContainer>
      <SearchedContainer ref={refSearchedContainer} className={state.isSearching && state.searchKeyword ? 'active' : 'noactive'}>
        <SearchListContainer>
          <PostTypePart>Blog</PostTypePart>
          {searchedList.map((list) => {
            return (
              <SearchItem 
                key={list.fields.slug_path}
                to={`/blog/${list.fields.slug_path}`}
                state={{
                  large: list.frontmatter.category_large,
                  small: list.frontmatter.category_small
                }}
              >
                <CategoryPart dangerouslySetInnerHTML={{__html: list.frontmatter.category_small}} />
                <PostPart>
                  <PostTitle dangerouslySetInnerHTML={{__html: list.frontmatter.title}} />
                  <PostContent dangerouslySetInnerHTML={{__html: list.excerpt}} />
                </PostPart>
              </SearchItem>
            )
          })}
        </SearchListContainer>
      </SearchedContainer>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  justify-self: flex-end;
  justify-content: flex-end;
  align-items: center;
`
const SearchIconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
const SearchIconStyled = styled(SearchIcon)`
  color: ${props => props.searching === 'false' && props.isTop ? props.theme.green : props.theme.white};
  background-color: ${props => props.searching === 'false' ? 'transparent' : props.isTop ? props.theme.green : 'transparent'};
  font-weight: bold;
  width: 3rem !important;
  height: 3rem !important;
  border-top-left-radius: ${props => props.searching === 'false' ? 'none' : '7px'};
  border-bottom-left-radius: ${props => props.searching === 'false' ? 'none' : '7px'};
  transform: all ease-out 0.3s;
  cursor: pointer;
  ${props => props.searching !== 'false' && !props.isTop ? (`
    border: 1px solid ${props.theme.white};
    border-right: none;
  `) : (`border: none;`)}
`
const SearchInput = styled.input`
  background-color: ${props => props.searching === `false` ? 'transparent' : !props.isTop ? 'transparent' : props.theme.green};
  height: 3rem;
  border: none;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
  width: 0;
  color: ${props => props.theme.white};
  padding: 0;
  font-size: 1.1rem;
  font-family: DINReg;
  letter-spacing: 0.07rem;
  outline: none;
  ${props => props.searching !== 'false' && !props.isTop ? (`
    border: 1px solid ${props.theme.white};
    border-left: none;
  `) : (`border: none;`)}
  &:focus {
    width: 10rem;
    padding: 0.3rem 1rem;
  }
`
const SearchedContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 5rem;
  right: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  opacity: 0;
  transform: translateX(9999px);
  transition: opacity 1s, transform 0.1s;
  &.active {
    opacity: 1;
    transform: translateX(0px);
    transition: opacity 1s, transform 0.1s;
  }
`
const SearchListContainer = styled.div`
  width: 90%;
  height: auto;
  background-color: ${props => props.theme.white};
  border: 1px solid ${props => props.theme.green};
  padding: 0.3rem 1rem;
  border-radius: 5px;
  @media(min-width: 900px) {
    width: 50%;
  }
`
const PostTypePart = styled.div`
  width: 100%;
  border-bottom: 1px solid gray;
  font-size: 1.2rem;
  font-family: ELEPHNT;
  font-weight: 100;
  padding-bottom: 0.3rem;
`
const SearchItem = styled(Link)`
  display: grid;
  grid-template-columns: 1fr 4fr;
  margin: 0.3rem 0;
  text-decoration: none;
  .match {
    color: ${props => props.theme.lightRed};
    text-decoration-line: underline;
    text-decoration-style: dotted;
  }
  &:hover {
    background-color: ${props => props.theme.green};
  }
  &:hover div {
    color: #fff;
  }
`
const CategoryPart = styled.div`
  display: inline-block;
  padding-right: 0.5rem;
  border-right: 1px solid ${props => props.theme.gray};
  color: ${props => props.theme.gray};
  font-size: 0.8rem;
  width: 100%;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
  text-align: right;
`
const PostPart = styled.div`
  padding-left: 0.5rem;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.gray};
`
const PostTitle = styled.div`
  font-size: 0.9rem;
  margin-bottom: 0.3rem;
  font-weight: bold;
  font-family: ELEPHNT;
  letter-spacing: 0.05rem;
  width: 100%;
  color: ${props => props.theme.green};
`
const PostContent = styled.div`
  display: inline-block;
  font-size: 0.8rem;
  width: 100%;
  height: 2rem;
  white-space: normal;
  text-overflow: ellipsis;
  color: ${props => props.theme.green};
`